"use client";
import { useMemo as p, useState as m, useEffect as I } from "react";
import { fileMatchesAccept as g } from "../../../utils/utils.mjs";
import { useFileInput as h } from "../../atoms/FileInput/useFileInput.mjs";
const v = "image/";
function U(r, e) {
  return e.length > 0 && !g(r, e) ? !1 : r.type.startsWith(v);
}
const w = (r, e = {}) => {
  var l;
  const n = p(() => e.accept ?? [], [e.accept]), a = ((l = e.accept) == null ? void 0 : l.length) ?? 0, s = h(r, {
    ...e,
    accept: n
  }), [f, i] = m(null);
  return I(() => {
    const { file: c } = s;
    if (!c) {
      i(null);
      return;
    }
    const o = (Array.isArray(c) ? c : [c]).filter((t) => U(t, n));
    if (o.length === 0) {
      i(null);
      return;
    }
    const u = o.map((t) => URL.createObjectURL(t));
    return i(u), () => {
      u.forEach((t) => URL.revokeObjectURL(t));
    };
  }, [s.file, a]), { ...s, previewUrls: f };
};
export {
  w as useImageFileInput
};
